import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import type { IPeriodTag, CreatePeriodTagDto } from '@carrierbridge/shared';
import api from '@/lib/api';

const PERIOD_TAGS_KEY = ['period-tags'] as const;

export function usePeriodTags() {
  return useQuery<IPeriodTag[]>({
    queryKey: PERIOD_TAGS_KEY,
    queryFn: async () => {
      const { data } = await api.get<IPeriodTag[]>('/period-tags');
      return data;
    },
  });
}

export function useCreatePeriodTag() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (dto: CreatePeriodTagDto) => {
      const { data } = await api.post<IPeriodTag>('/period-tags', dto);
      return data;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: PERIOD_TAGS_KEY }),
  });
}
